import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static outlets = ['selectable-table']
  static values = {
    schoolId: Number,
    updateUsersPath: String,
    inviteUsersPath: String,
    dropoffPinsPath: String,
  }

  email() {
    const path = `/s/${this.schoolIdValue}/emails?via=email&user_ids=${this.selectedIds().join()}`

    window.open(path, 'email')
  }

  text() {
    const path = `/s/${this.schoolIdValue}/emails?via=sms&user_ids=${this.selectedIds().join()}`

    window.open(path, 'email')
  }

  toggleActive(event) {
    this.constructor.setBusy(event.target)

    $.ajax({
      url: this.updateUsersPathValue,
      type: 'PUT',
      data: { id: this.selectedIds(), user: { inactive: !event.params.active } },
      success: () => {
        window.location.reload()
      },
    })
  }

  sendInvitations(event) {
    this.constructor.setBusy(event.target)

    $.ajax({
      url: this.inviteUsersPathValue,
      type: 'POST',
      data: { user_ids: this.selectedIds() },
      success: () => {
        window.location.reload()
      },
      error: () => {
        window.location.assign('/500')
      },
    })
  }

  sendDropoffPins(event) {
    this.constructor.setBusy(event.target)

    $.ajax({
      url: this.dropoffPinsPathValue,
      type: 'POST',
      data: { user_ids: this.selectedIds() },
      success: () => {
        window.location.reload()
      },
      error: () => {
        window.location.assign('/500')
      },
    })
  }

  selectedIds() {
    return this.selectableTableOutlet.selectedIds()
  }

  static setBusy(element) {
    element.toggleAttribute('disabled', true)
    element.classList.add('disabled')

    const spinner = document.createElement('i')
    spinner.classList.add('fas', 'fa-spinner', 'fa-spin', 'ml-2')
    element.append(spinner)
  }
}
